/**
 * "Select All" for a product search (Notification and Story forms).
 * Works on the current search results only; products picked from earlier searches stay picked.
 */
type WithItemNumber = { Item_Number: number | string };

/** How many of the current results are already picked (drives checked / indeterminate). */
export const countSelectedResults = <T extends WithItemNumber>(selected: T[], results: T[]): number =>
  results.filter((r) => selected.some((p) => p.Item_Number === r.Item_Number)).length;

/** All results already picked → unpick them; otherwise add the ones not picked yet. */
export const toggleSelectAllResults = <T extends WithItemNumber>(selected: T[], results: T[]): T[] => {
  const allSelected = results.length > 0 && countSelectedResults(selected, results) === results.length;
  if (allSelected) {
    const resultIds = new Set(results.map((r) => r.Item_Number));
    return selected.filter((p) => !resultIds.has(p.Item_Number));
  }
  return [...selected, ...results.filter((r) => !selected.some((p) => p.Item_Number === r.Item_Number))];
};
